import axios from 'axios'

// config
import baseUrl from '../config'

export const requestCommunityBoost = async data => {
  return axios.post(`${baseUrl}/community-boosts`, { data, withCredentials: true })
}
